import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../../constants";
import { FormControl, Grid, TextField, InputLabel, Select, MenuItem, Typography, FormHelperText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { defaultValuesFormat } from "./models";
import { useStateValue } from "../../../context/store";
import ModalConfirmBase from "../../../utils/form/modalConfirmBase";
import { saveContractTypeFormat } from "../../../actions/contract-type-actions";
import { withRouter } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
  dialogPaper: {
    minHeight: '400px'
  },
}));

const DialogCreateFormat = ({
  handleClose,
  open,
  setOpen,
  contractTypeId,
  setRefreshFormat,
  refreshFormat,
  history,
  typeContractName
}) => {
  const classes = useStyles();
  const [{ breadCrumb }, dispatch] = useStateValue();
  var currentDate = new Date();
  currentDate.setMinutes(
    currentDate.getMinutes() + currentDate.getTimezoneOffset()
  );
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => { },
    handleClickOut: () => { },
    oneButtons: false,
    type: "",
    open: false,
  });

  const schema = yup.object().shape({
    name: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(100, "Ingrese máximo 100 caracteres"),
    status: yup
      .string()
      .typeError("Este campo es obligatorio")
      .required(REQUIRED_MESSAGE)
    ,
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValuesFormat,
    mode: "all",
    reValidateMode: "onChange",
  });

  const closeMessage = (id, name) => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
    setOpen(!open);

    history.push(`/dashboard/type-contracts/configuration/${id}/${name}`);
  };

  const createFormat = async (data) => {
    data.contractTypeId = contractTypeId;
    const saveResponse = await saveContractTypeFormat(data, dispatch);
    if (
      saveResponse &&
      saveResponse.status >= 200 &&
      saveResponse.status < 399
    ) {
      const id = saveResponse?.data;
      setRefreshFormat(!refreshFormat);
      setMessage(() => ({
        open: true,
        description: `Registro creado exitosamente`,
        type: "SUCCESS",
        handleClick: () => closeMessage(id, data.name),
        oneButtons: true,
      }));
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: saveResponse?.data?.detail
            ? saveResponse?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  }

  return (
    <div>
      {message.open && (
        <ModalConfirmBase
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          type={message.type}
          open={message.open}
        />
      )}
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        PaperProps={{
          style: { borderRadius: 16, padding: 30, maxWidth: "400px", minHeight: "400px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <form onSubmit={handleSubmit(createFormat)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12} style={{ textAlign: "center" }}>
              <svg width="80" height="80" viewBox="0 0 80 80" fill="#e0f2f7" xmlns="http://www.w3.org/2000/svg">
                <path d="M36.0415 20.2084H43.9582V28.1251H36.0415V20.2084ZM36.0415 36.0417H43.9582V59.7918H36.0415V36.0417ZM39.9998 0.416748C18.1498 0.416748 0.416504 18.1501 0.416504 40.0001C0.416504 61.8501 18.1498 79.5834 39.9998 79.5834C61.8498 79.5834 79.5832 61.8501 79.5832 40.0001C79.5832 18.1501 61.8498 0.416748 39.9998 0.416748ZM39.9998 71.6667C22.5436 71.6667 8.33317 57.4563 8.33317 40.0001C8.33317 22.5438 22.5436 8.33342 39.9998 8.33342C57.4561 8.33342 71.6665 22.5438 71.6665 40.0001C71.6665 57.4563 57.4561 71.6667 39.9998 71.6667Z" fill="#4d8d9d" fill-opacity="1" />
              </svg>
            </Grid>
            <Grid item xs={12} md={12} lg={12} style={{ textAlign: "center", marginBottom: "15px" }}>
              <Typography>{typeContractName}</Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  className={classes.formField}
                  inputProps={{
                    style: {
                      height: "18px",
                      borderRadius: "8px",
                      paddingBottom: "6.5px",
                      fontSize: 14,
                    },
                  }}
                  label="Nombre del formato tipo de contrato"
                  name="name"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={
                    !!errors.hasOwnProperty("name") &&
                    errors["name"].message
                  }
                  helperText={
                    errors.hasOwnProperty("name") &&
                    errors["name"].message
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("status") && errors["status"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-status"
                  shrink={true}
                  size="small"
                >
                  Estado
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className={classes.dropdown}
                  label="Estado"
                  size="small"
                  name="status"
                  notched={true}
                  defaultValue={null}
                  inputProps={{
                    name: "status",
                    id: "outlined-select-status",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      <MenuItem value="Activo">Activo</MenuItem>
                      <MenuItem value="Inactivo">Inactivo</MenuItem>
                    </Select>
                  }
                />
                <FormHelperText>
                  {errors.hasOwnProperty("status") && errors["status"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <DialogActions
              style={{ justifyContent: "center", paddingTop: "20px", width: "100%" }}
            >
              <Button
                onClick={handleClose}
                color="primary"
                variant="outlined"
                style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                color="primary"
                autoFocus
                style={{ backgroundColor: "#7EBDCE", color: "#ffffff" }}
              >
                Continuar
              </Button>
            </DialogActions>
          </Grid>
        </form>
      </Dialog>
    </div>
  );
};
export default withRouter(DialogCreateFormat);
